@if (showButton) {
  <button class="print mat-button-base" mat-button aria-label="Print" (click)="onPrintPage()">
    <img alt="print" src="/content/dam/generic/en/healthco/shopx/icons/print.svg">
    <span aria-hidden="true" aria-label="Print">
      {{ label || "Print" }}
    </span>
  </button>
}